let adCore = (function () {
    let pub = {};

    /**
     * DFP TOOLS
     * */
    function initDfp() {
        window.googletag = window.googletag || {};
        window.googletag.cmd = window.googletag.cmd || [];

        if(window.googletag.cmd.length === 0){
            let gads = document.createElement('script');
            gads.async = true;
            gads.type = 'text/javascript';
            gads.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
            let node = document.getElementsByTagName('script')[0];
            node.parentNode.insertBefore(gads, node);
        }
    }

    pub.defineDfpSlot = function(params) {
        initDfp();

        //check is DFP core initialized
        if (!window.hasOwnProperty('googletag')) {
            console.warn('DFP core is not initialized!');
            return false;
        }

        let googletag = window.googletag, slot;

        //create DFP slot
        googletag.cmd.push(function() {
            slot = googletag.defineSlot(params.name, params.sizes, params.id);

            for (let i = 0; i < params.targeting.length; i++) {
                if (params.targeting[i] !== null && params.targeting[i][0] !== null && params.targeting[i][1] !== null){
                    slot.setTargeting(params.targeting[i][0], params.targeting[i][1]);
                }
            }

            slot.addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();

            if (params.hasOwnProperty('callback') && typeof params.callback === 'function') {

                googletag.pubads().addEventListener('slotRenderEnded', function(e) {
                    //mobileAdSlot && event.slot === mobileAdSlot && !event.isEmpty
                    if (e.slot === slot) {
                        params.callback(e);
                    }
                });
            }

            googletag.enableServices();
        });
        return slot;
    };

    /**
     * RESPONSIVE TOOLS
     * */
    pub.isLargerThan = function(size) {
        return (window.matchMedia && window.matchMedia("(min-width: " + size + "px)").matches) ? true : false;
    };

    pub.isSmallerThan = function(size) {
        return !pub.isLargerThan(size);
    };

    /**
     * GET PAGE NAME
     * */
    pub.getPageName = function() {
        /* obId matcher */
        let newsIdMatcher = document.location.href.match(/(_n|objectId=|tagId=)(\d+)/i) || [];
        if (newsIdMatcher && newsIdMatcher.length >= 3) {
            if (typeof newsIdMatcher[2] === 'string') {
                return newsIdMatcher[2];
            }
        }

        if (document.location.pathname === '/'
            || document.location.pathname === '/football24/'
            || document.location.pathname === '/ru/') {
            return "main";
        }

        if (document.location.href.match(/forecast_score|game_gid|showGame.do|showForecastScore.do|forecast_/gi)) {
            return "forecast";
        }

        if(document.location.href.match(/\/home\//)) {
            return document.location.pathname;
        }

        return "site";
    };

    pub.isMobile = function () {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };

    /**
     * UTILS
     * */
    pub.throttle = function throttle(fn, wait) {
        let time = Date.now();
        return function () {
            if ((time + wait - Date.now()) < 0) {
                fn();
                time = Date.now();
            }
        }
    };

    return pub;
})();

/**
 * TARGETING
 * */
adCore.targeting = (function() {
    let targeting = [];

    return {
        set: function(key, value) {
            targeting.push([key, value]);
        },

        getAll: function() {
            return targeting;
        }
    }
})();

module.exports = adCore;